import React from "react";
import { StoryNode } from "../../StoryBook/StoryData";
import {
    PropertyEditorVariableSelection,
    PropertyEditorVariableSelectionInterface,
} from "../PropertyEditorVariableSelection";
import { getFilledDataDefinition } from "../../../rule-engine-core/Common/Data/DataTestData";
import { StringDataDefinition } from "../../../rule-engine-core/Common/Data/Definitions/StringDataDefinition";
import { ObserveState } from "../../StateManagement/ObserveState";
import { IDataDefinition } from "../../../rule-engine-core/Common/Data/Definitions/IDataDefinition";
import { DataDefinition } from "../../../rule-engine-core/Common/Data/DataDefinition";
import { IDesignValidationProvider, ValidationIssue } from "../../../rule-engine-core/Common/IDesignValidationProvider";

const datadef = getFilledDataDefinition();

class SectionData implements PropertyEditorVariableSelectionInterface {
    editObject: object = {};
    label: string = "First Name";
    propertyName: string = "firstName";
    expectedType: IDataDefinition = new StringDataDefinition();
    allowNew: boolean = true;

    inputDataFunction: () => DataDefinition = () => {
        return datadef;
    };
}

class SectionData2 implements PropertyEditorVariableSelectionInterface {
    editObject: IDesignValidationProvider = {
        getDesignValidationIssues(): ValidationIssue[] {
            return [new ValidationIssue("issue", "firstName"), new ValidationIssue("issue2", "firstName")];
        },
    };
    label: string = "First Name";
    propertyName: string = "firstName";
    expectedType: IDataDefinition = new StringDataDefinition();
    allowNew: boolean = true;

    inputDataFunction: () => DataDefinition = () => {
        return datadef;
    };
}

export const PropertyEditorVariableSelectionStories = [
    new StoryNode(
        (logCallback) => {
            const params = new SectionData();
            return (
                <ObserveState
                    listenTo={params.editObject}
                    control={() => (
                        <PropertyEditorVariableSelection
                            {...params}
                            onChange={() => logCallback(Reflect.get(params.editObject, params.propertyName))}
                        />
                    )}
                />
            );
        },
        "Shared",
        "Property Editors",
        "VariableSelection",
        "Default",
    ),
    new StoryNode(
        (logCallback) => {
            const params = new SectionData();
            return (
                <ObserveState
                    listenTo={params.editObject}
                    control={() => (
                        <PropertyEditorVariableSelection
                            {...params}
                            error={"error text"}
                            onChange={() => logCallback(Reflect.get(params.editObject, params.propertyName))}
                        />
                    )}
                />
            );
        },
        "Shared",
        "Property Editors",
        "VariableSelection",
        "Error",
    ),
    new StoryNode(
        (logCallback) => {
            const params = new SectionData2();
            return (
                <ObserveState
                    listenTo={params.editObject}
                    control={() => (
                        <PropertyEditorVariableSelection
                            {...params}
                            onChange={() => logCallback(Reflect.get(params.editObject, params.propertyName))}
                        />
                    )}
                />
            );
        },
        "Shared",
        "Property Editors",
        "VariableSelection",
        "Validation Provider",
    ),
];
